import apiClient from './client';
import type {
  EditorActivityDetail,
  EditorActivitySummary,
  RecordPageVisitRequest,
} from '../types/editorActivity';

// Feature 015 — Editor Session Tracking client.
export const editorActivityApi = {
  // Best-effort, fire-and-forget page-visit beacon. Callers MUST NOT await on the
  // critical path; failures are swallowed so capture never disrupts the editor
  // (FR-008). skipErrorRedirect prevents the shared interceptor from bouncing the
  // user to an error page on a dropped beacon.
  recordPageVisit: (request: RecordPageVisitRequest): void => {
    // skipErrorRedirect is a custom flag the shared interceptor reads; cast keeps
    // it off the typed AxiosRequestConfig surface.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const config = { skipErrorRedirect: true } as any;
    apiClient.post('/editor-activity/page-visits', request, config).catch(() => {
      /* best-effort: ignore */
    });
  },

  // Admin reads.
  listActivity: async (): Promise<EditorActivitySummary[]> => {
    const response = await apiClient.get<EditorActivitySummary[]>('/admin/editor-activity');
    return response.data;
  },

  getActivity: async (userId: number): Promise<EditorActivityDetail> => {
    const response = await apiClient.get<EditorActivityDetail>(`/admin/editor-activity/${userId}`);
    return response.data;
  },
};
